/**
 * **Adressen des Notizbuchs** – von `index.tsx` (Hauptbündel) und `seite.tsx` (eigenes Bündel)
 * gemeinsam benutzt, deshalb in einer eigenen kleinen Datei.
 */

/** Wie die Navigation von Work: der Pfad als Zeichenkette, nicht aus dem Routenbaum abgeleitet. */
export const PFAD: string = '/notizbuch'

/** Sprungmarke `#neu`: „Neues Blatt" von außerhalb (⌘K, später Kurzbefehl am Telefon). */
export const NEUES_BLATT = 'neu'

/** Sprungmarke `#frag-<Frage>`: „? frag" aus ⌘K – das Notizbuch fragt sofort (Konzept K:855). */
export const FRAG = 'frag-'

/**
 * Sprungmarke `#mappe-<notizbuch>-<mappe>`: eine Mappe direkt öffnen – für „in neuem Tab" (Nils,
 * 23.10.: *„aus Mappen am besten immer neuen Tab öffnen, sonst kann man nicht so gut springen"*).
 */
export const MAPPE = 'mappe-'
export const mappenAdresse = (nb: string, id: string): string =>
  `${PFAD}#${MAPPE}${nb}-${encodeURIComponent(id)}`

/**
 * Kennzeichen **schnelle Notiz** (Tag im Kopf, 23.10.2026): gesetzt beim Schnell-Erfassen und aus My
 * Work. Work legt sie nie von selbst ab; die Leiste zeigt sie unter „Schnelle Notizen".
 */
export const SCHNELLE_NOTIZ = 'schnelle-notiz'
